"use client";

import { UpcomingEvents } from "../../../../../components/arrangement/UpcomingEvents";
import { DefaultContainer } from "../../../../../components/ContentContainer";
import { DefaultPageLayout } from "../../../../../components/layout/DefaultPageLayout";
import SeeAllButton from "../../../../../components/SeeAllButton";
import { useTranslation } from "../../../../../utils/hooks/useTranslation";
import { SanityDataWithPreviewConfig } from "../../../../sanityFetcher/getAppFolderPageProps";
import { SanityPreviewLiveQuery } from "../../../../sanityFetcher/SanityPreviewLiveQuery";
import { EventListData } from "./page";

type Props = {
  sanityData: SanityDataWithPreviewConfig<EventListData>;
};

export const ClientSideEventsListPage = (props: Props) => {
  const { t } = useTranslation();

  return (
    <SanityPreviewLiveQuery sanityData={props.sanityData}>
      {({ hasFinishedEvents, initialData, hasUnfinishedEvents }) => (
        <DefaultPageLayout>
          <UpcomingEvents initialData={initialData} hasUnfinishedEvents={hasUnfinishedEvents} />
          {hasFinishedEvents && (
            <DefaultContainer marginTop="4rem">
              <SeeAllButton url="/arrangementer/avholdte-arrangementer" title={t("Se avholdte arrangementer")} />
            </DefaultContainer>
          )}
        </DefaultPageLayout>
      )}
    </SanityPreviewLiveQuery>
  );
};
